<template>
  <div class="popular-item-container">
    <p v-if="popularItemsData.articles.length > 0">{{ popularItemsData.title }}</p>
    <div v-for="data in popularItemsData.articles" :key="data.title" class="inner-container">
      <!-- NOSONAR -->
      <a :href="data.url" :title="data.title">
        <img :alt="data.alt" :src="data.image" />
      </a>
      <h4>{{ data.title }}</h4>
      <div v-if="popularItemsData.ctabuttontext != ''" class="btn-container">
        <a
          :href="data.url"
          role="button"
          class=""
          @click="buttondatalayer(popularItemsData.title, popularItemsData.ctabuttontext, data.url)"
        >
          <strong>{{ popularItemsData.ctabuttontext }}</strong>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popular-items',
  props: {
    popularItemsData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    buttondatalayer(title, buttontxt, url) {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'content page',
        eventAction: `select::${title}`,
        eventLabel: `${buttontxt}::${url}`,
        ecommerce: 'undefined',
        event_name: 'body_button_click',
        module_name: title,
        cta_name: buttontxt,
        link_url: url,
      });
    },
  },
};
</script>
